import * as R from 'ramda';
import { useQuery } from '@cd/react-query';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';

export default function useWidgets(dispatch) {
	return useQuery(
		'widgets',
		() =>
			postJSONPS('GET', '/get/widgets').then(
				either(e => {
					dispatch({ type: 'post error', e });
					throw new Error(e);
				}, R.identity)
			),
		{ refetchOnWindowFocus: false }
	);
}
